"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Card = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _clsx8 = _interopRequireDefault(require("clsx"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _core = require("@material-ui/core");
var _Card = _interopRequireDefault(require("@material-ui/core/Card"));
var _styles = require("@material-ui/core/styles");
var _links = require("../_utils/links");
var _Image = _interopRequireDefault(require("../Image"));
var _RichText = _interopRequireDefault(require("../RichText"));
var _lodash = require("lodash");
var _commonUtils = require("@sial/common-utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    wrapper: {
      boxShadow: 'none',
      minHeight: '414px',
      display: 'flex',
      'flex-wrap': 'wrap',
      alignContent: 'flex-start',
      '@media (max-width: 900px)': {
        height: "auto",
        minHeight: 'auto'
      }
    },
    shadowWrapper: {
      padding: theme.spacing(6),
      boxShadow: "0 0 4px 0 ".concat(theme.palette.grey[500]),
      minHeight: 410,
      '@media (max-width: 900px)': {
        height: "auto",
        minHeight: 'auto'
      }
    },
    outlineWrapper: {
      padding: theme.spacing(6),
      border: '1px solid rgba(201, 201, 201, 0.5)',
      borderRadius: theme.spacing(1.25),
      minHeight: 410,
      '@media (max-width: 900px)': {
        height: 'auto',
        minHeight: 'auto'
      }
    },
    stackedWrapper: {
      height: 'auto',
      flexWrap: 'nowrap',
      minHeight: 'auto'
    },
    imageWrapper: {
      flex: '1 1 100%',
      margin: theme.spacing(0, 0, 4, 0)
    },
    stackedImageWrapper: (0, _defineProperty2.default)({
      flex: 'none',
      margin: theme.spacing(0, 8, 0, 0)
    }, theme.breakpoints.down('xs'), {
      display: 'none'
    }),
    itemTitle: {
      fontWeight: theme.typography.fontWeightMedium,
      wordBreak: 'break-word'
    },
    ctaLink: {
      fontWeight: theme.typography.fontWeightBold,
      display: 'block'
    },
    topWrapper: {
      marginBottom: theme.spacing(12),
      borderRadius: '5px',
      backgroundColor: theme.palette.common.white,
      position: 'relative',
      '&.cardSecondary$bgColorPadding': {
        '& .MuiTypography-body1': {
          '& > a$ctaLink': {
            bottom: 24,
            '@media (max-width: 900px)': {
              position: 'unset'
            }
          }
        }
      },
      '& $bgColorShadow': {
        minHeight: 410,
        '@media (max-width: 900px)': {
          height: "auto",
          minHeight: 'auto'
        }
      },
      '&.cardSecondary': {
        '& .aem-ms-image-cmp--link': {
          color: theme.palette.common.black
        },
        '& $stackedWrapper': {
          '& a$ctaShadowLink': {
            position: 'unset'
          },
          '& a$ctaLink': {
            position: 'unset'
          }
        },
        '& .MuiTypography-body1': {
          '& p': {
            display: ' -webkit-box',
            WebkitLineClamp: '5',
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          },
          '& > a': {
            pointerEvents: 'none',
            color: theme.palette.common.black,
            '&[color="primary"]': {
              pointerEvents: 'initial',
              padding: '5px 24px',
              fontSize: '14px',
              display: 'inline-flex',
              color: theme.palette.primary.main,
              border: "1px solid ".concat(theme.palette.primary.main),
              backgroundColor: theme.palette.common.white,
              borderRadius: '5px',
              lineHeight: '24.5px',
              '&:hover': {
                borderColor: theme.palette.primary.dark,
                color: theme.palette.primary.dark
              }
            }
          },
          '& > a$ctaShadowLink': {
            color: theme.palette.primary.main,
            cursor: 'pointer',
            pointerEvents: 'auto',
            position: 'absolute',
            bottom: 20
          },
          '& > a$ctaLink': {
            position: 'absolute',
            bottom: 0,
            '@media (max-width: 900px)': {
              position: 'unset'
            }
          }
        }
      }
    },
    injectedImageWrapper: {
      '& img': {
        marginBottom: theme.spacing(0),
        width: '100%',
        height: '100%',
        minWidth: '0px'
      }
    },
    stackedModifier: {
      '& img': {
        minWidth: '290px'
      }
    },
    shadowModifier: {
      '& img': {
        maxHeight: 'none'
      },
      '&$stackedModifier': {
        '& img': {
          minWidth: '242px'
        }
      }
    },
    card: {
      display: 'block',
      backgroundColor: theme.palette.common.white,
      border: "1px solid ".concat(theme.palette.grey[300]),
      boxShadow: 'none',
      width: '100%',
      marginBottom: theme.spacing(2),
      '&:focus-visible': {
        outlineColor: theme.palette.primary.main
      }
    },
    brandColorContainer: {
      display: 'block',
      height: '100%',
      width: 16
    },
    textContainer: {
      padding: theme.spacing(4, 0)
    },
    brandTitle: {
      lineHeight: theme.typography.pxToRem(24),
      margin: "".concat(theme.spacing(0, 0, 1), " !important")
    },
    brandDescription: {
      fontSize: theme.typography.pxToRem(14),
      marginBottom: '0 !important',
      '& a': {
        color: theme.palette.common.black,
        fontWeight: 'normal'
      },
      '& p': {
        marginBottom: 0
      }
    },
    cardGrid: {
      minHeight: 92
    },
    cardLinkWrapper: {
      width: '100%'
    },
    displayTextWrapper: {
      marginBottom: theme.spacing(6),
      marginTop: theme.spacing(1),
      '&$truncated p': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: "4 !important",
        WebkitBoxOrient: 'vertical',
        marginBottom: 0,
        wordBreak: 'break-word'
      }
    },
    ctaShadowLink: {},
    bgColorShadow: {},
    portfolioCardWrapper: {
      padding: 0,
      height: 'auto',
      minHeight: 'auto'
    },
    portfolioCardTopWrapper: {
      border: '0 none',
      borderRadius: 0
    },
    truncated: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical'
    },
    bgColorPadding: {
      padding: theme.spacing(6),
      border: "solid 1px ".concat(theme.palette.grey[300])
    },
    noCtaWrapper: {
      '& $displayTextWrapper': {
        marginBottom: 0
      },
      '& $wrapper': {
        minHeight: 'unset'
      }
    },
    noCtaText: {
      '& $displayTextWrapper': {
        '@media (min-width: 900px)': {
          minHeight: 96
        }
      }
    },
    noTextTitle: {
      minHeight: 48
    },
    noCtaShadowText: {
      minHeight: 152
    }
  };
});
var Card = function Card(props) {
  var _clsx, _clsx2, _clsx3, _clsx4, _clsx5, _clsx6;
  var heading = props.heading,
    text = props.text,
    url = props.url,
    imageTitle = props.imageTitle,
    image = props.image,
    _props$stacked = props.stacked,
    stacked = _props$stacked === void 0 ? false : _props$stacked,
    _props$shadow = props.shadow,
    shadow = _props$shadow === void 0 ? false : _props$shadow,
    ctaLabel = props.ctaLabel,
    anchorId = props.anchorId,
    portfolioBrandColor = props.portfolioBrandColor,
    _props$outline = props.outline,
    outline = _props$outline === void 0 ? false : _props$outline;
  var classes = useStyles({
    stacked: stacked,
    shadow: shadow,
    outline: outline
  });
  var cardRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    imageLoaded = _useState[0],
    setImageLoaded = _useState[1];
  var theme = (0, _styles.useTheme)();
  var isDesktop = (0, _core.useMediaQuery)(theme.breakpoints.up('sm'), {
    defaultMatches: true
  });
  var isBrowser = typeof window !== 'undefined';
  var isPortfolioCard = !!portfolioBrandColor;
  var imageClasses = {
    wrapper: (0, _clsx8.default)(classes.injectedImageWrapper, (_clsx = {}, (0, _defineProperty2.default)(_clsx, classes.shadowModifier, shadow), (0, _defineProperty2.default)(_clsx, classes.stackedModifier, stacked), _clsx))
  };
  var hasParentElementWithClass = (0, _react.useCallback)(function (element, className, limit) {
    var currentElement = element.parentElement;
    var count = 0;
    while (currentElement && count < limit) {
      if (currentElement.classList && currentElement.classList.contains(className)) {
        return true;
      }
      currentElement = currentElement.parentElement;
      count++;
    }
    return false;
  }, []);
  var isBgColorContainer = isBrowser && cardRef && cardRef.current && hasParentElementWithClass(cardRef.current, 'container-spacing', 4);
  var linkProps = url && (0, _links.getTarget)(url);
  var isGTMEnabled = function isGTMEnabled() {
    var _window;
    return typeof window !== 'undefined' && ((_window = window) === null || _window === void 0 ? void 0 : _window.dataLayer);
  };
  var handlePortfolioClick = function handlePortfolioClick() {
    if (!isGTMEnabled) return;
    isPortfolioCard && _commonUtils.Analytics.sendGTMEvent({
      eventType: _commonUtils.GTMEventTypes.AnalyticsEvent,
      payload: {
        event: 'navigation_interaction',
        action: 'shortcut click',
        detail: undefined,
        section: 'discover our brands',
        component: 'body',
        element_type: 'link',
        element_text: heading.replace(/(<([^>]+)>)/gi, '').replace(/[^\w\s]/gi, '').toLowerCase(),
        link_url: url,
        core_event: 'no',
        user_detail: undefined,
        event_group: undefined,
        event_subgroup: undefined
      }
    });
  };
  (0, _react.useEffect)(function () {
    var curRefCard = cardRef.current;
    var isFeatureCardsContainer = cardRef && curRefCard && hasParentElementWithClass(curRefCard, 'feature-cards-container-grid', 3);
    var calculateHeight = function calculateHeight() {
      if (isDesktop || !isFeatureCardsContainer) return;
      var cards = document.querySelectorAll('.feature-cards-container-grid .cardTopWrapper > div');
      if (cards.length) {
        Array.from(cards).forEach(function (card) {
          var ctaLink = card.querySelector('.MuiTypography-root.MuiTypography-body1 a.ctaLinkElement');
          card.style.height = "auto";
          if (ctaLink) ctaLink.style.position = 'unset';
        });
        //Need a timeout to make sure we get the updated height whenever the text changes.
        setTimeout(function () {
          // Calculate the maximum height among all cards in a row
          var heights = Array.from(cards).map(function (card) {
            return card.offsetHeight;
          });
          var maxHeight = Math.max.apply(Math, (0, _toConsumableArray2.default)(heights));
          // Set the height of all cards in the row to the maximum height
          Array.from(cards).forEach(function (card) {
            var ctaLink = card.querySelector('.MuiTypography-root.MuiTypography-body1 a.ctaLinkElement');
            card.style.height = "".concat(maxHeight, "px");
            if (ctaLink) ctaLink.style.position = 'absolute';
          });
        }, 0);
      }
    };
    var resizeHandler = (0, _lodash.throttle)(function () {
      calculateHeight();
    }, 100);
    //Call the calculateHeight function for mobile only
    if (!stacked && !isPortfolioCard) {
      // Call the calculateHeight function if the image is already loaded
      if (imageLoaded) {
        calculateHeight();
      } else {
        // Otherwise, wait for the image to load and then call calculateHeight
        var cardImg = cardRef && curRefCard && curRefCard.querySelector('img');
        cardImg && cardImg.addEventListener('load', calculateHeight, false);
        if (cardImg && cardImg.complete) {
          calculateHeight.call(cardImg);
          cardImg && cardImg.removeEventListener('load', calculateHeight, false);
        }
      }
    }
    window.addEventListener('resize', resizeHandler);
    // Cleanup: remove the event listener
    return function () {
      var cardImg = cardRef && curRefCard && curRefCard.querySelector('img');
      cardImg && cardImg.removeEventListener('load', calculateHeight);
      window.removeEventListener('resize', resizeHandler);
    };
  }, [text, imageLoaded, stacked, isPortfolioCard, isDesktop, hasParentElementWithClass]);
  return isDesktop || !portfolioBrandColor ? __jsx("div", {
    id: anchorId,
    className: (0, _clsx8.default)(classes.topWrapper, !stacked && !isPortfolioCard ? 'cardTopWrapper' : '', ctaLabel ? 'cardSecondary' : classes.noCtaWrapper, !ctaLabel && 'noCtaContainer', isPortfolioCard ? classes.portfolioCardTopWrapper : '', isBgColorContainer ? !shadow && !outline ? classes.bgColorPadding : '' : '')
  }, __jsx("div", {
    className: (0, _clsx8.default)(classes.wrapper, (_clsx2 = {}, (0, _defineProperty2.default)(_clsx2, classes.stackedWrapper, stacked), (0, _defineProperty2.default)(_clsx2, classes.shadowWrapper, shadow), (0, _defineProperty2.default)(_clsx2, classes.outlineWrapper, outline), (0, _defineProperty2.default)(_clsx2, classes.portfolioCardWrapper, isPortfolioCard), (0, _defineProperty2.default)(_clsx2, classes.bgColorShadow, shadow && isBgColorContainer), _clsx2)),
    ref: cardRef
  }, image && __jsx("div", {
    className: (0, _clsx8.default)((_clsx3 = {}, (0, _defineProperty2.default)(_clsx3, classes.imageWrapper, !stacked), (0, _defineProperty2.default)(_clsx3, classes.stackedImageWrapper, stacked), _clsx3)),
    onClick: handlePortfolioClick
  }, __jsx(_Image.default, (0, _extends2.default)({}, image, {
    title: imageTitle || image.title,
    size: "xs",
    classesInjected: imageClasses,
    link: url,
    imageLoadHandler: setImageLoaded
  }))), __jsx(_core.Typography, {
    component: "div",
    className: (0, _clsx8.default)((_clsx4 = {}, (0, _defineProperty2.default)(_clsx4, classes.noCtaText, !ctaLabel), (0, _defineProperty2.default)(_clsx4, classes.noCtaShadowText, shadow && !!text && !ctaLabel), _clsx4))
  }, url ? __jsx("a", (0, _extends2.default)({
    href: url,
    className: (0, _clsx8.default)(classes.itemTitle, (_clsx5 = {}, (0, _defineProperty2.default)(_clsx5, classes.truncated, !stacked), (0, _defineProperty2.default)(_clsx5, classes.noTextTitle, !text && !ctaLabel), _clsx5)),
    dangerouslySetInnerHTML: {
      __html: heading
    },
    onClick: handlePortfolioClick
  }, linkProps)) : __jsx("div", {
    className: (0, _clsx8.default)(classes.itemTitle, (_clsx6 = {}, (0, _defineProperty2.default)(_clsx6, classes.truncated, !stacked), (0, _defineProperty2.default)(_clsx6, classes.noTextTitle, !text && !ctaLabel), _clsx6)),
    dangerouslySetInnerHTML: {
      __html: heading
    }
  }), !!text ? __jsx("div", {
    className: (0, _clsx8.default)(classes.displayTextWrapper, (0, _defineProperty2.default)({}, classes.truncated, !stacked))
  }, text && __jsx(_RichText.default, {
    text: text
  })) : null, ctaLabel && (url ? !shadow && !outline ? __jsx("a", (0, _extends2.default)({
    href: url,
    color: "primary",
    className: (0, _clsx8.default)(classes.ctaLink, 'ctaLinkElement'),
    dangerouslySetInnerHTML: {
      __html: ctaLabel
    }
  }, linkProps, {
    "data-event": true,
    "data-dlname": true,
    "data-dltype": true,
    "data-dltext": true
  })) : __jsx("a", (0, _extends2.default)({
    href: url,
    className: (0, _clsx8.default)(classes.ctaShadowLink, 'ctaLinkElement'),
    dangerouslySetInnerHTML: {
      __html: ctaLabel
    }
  }, linkProps, {
    "data-event": true,
    "data-dlname": true,
    "data-dltype": true,
    "data-dltext": true
  })) : __jsx("div", {
    className: (0, _clsx8.default)(classes.ctaLink, 'ctaLinkElement'),
    dangerouslySetInnerHTML: {
      __html: ctaLabel
    }
  }))))) : __jsx(_react.default.Fragment, null, url ? __jsx(_core.Link, {
    href: url,
    className: classes.cardLinkWrapper
  }, __jsx(_Card.default, {
    component: "div",
    className: classes.card,
    onClick: handlePortfolioClick
  }, __jsx(_core.Grid, {
    container: true,
    className: classes.cardGrid,
    direction: "row"
  }, __jsx(_core.Grid, {
    item: true,
    xs: 1
  }, __jsx("span", {
    style: {
      backgroundColor: "".concat(portfolioBrandColor)
    },
    className: classes.brandColorContainer
  })), __jsx(_core.Grid, {
    className: classes.textContainer,
    item: true,
    xs: 9
  }, __jsx(_core.Typography, {
    variant: "h3",
    className: classes.brandTitle
  }, __jsx("div", {
    dangerouslySetInnerHTML: {
      __html: heading
    }
  })), __jsx(_core.Typography, {
    className: classes.brandDescription
  }, text && __jsx(_RichText.default, {
    text: text
  })))))) : __jsx(_Card.default, {
    component: "div",
    className: classes.card
  }, __jsx(_core.Grid, {
    container: true,
    className: classes.cardGrid,
    direction: "row"
  }, __jsx(_core.Grid, {
    item: true,
    xs: 1
  }, __jsx("span", {
    style: {
      backgroundColor: "".concat(portfolioBrandColor)
    },
    className: classes.brandColorContainer
  })), __jsx(_core.Grid, {
    className: classes.textContainer,
    item: true,
    xs: 9
  }, __jsx(_core.Typography, {
    variant: "h3",
    className: classes.brandTitle
  }, __jsx("div", {
    dangerouslySetInnerHTML: {
      __html: heading
    }
  })), __jsx(_core.Typography, {
    className: classes.brandDescription
  }, text && __jsx(_RichText.default, {
    text: text
  }))))));
};
exports.Card = Card;
var CardEditConfig = {
  emptyLabel: 'Card',
  isEmpty: function isEmpty(props) {
    if (props.heading) {
      return false;
    } else {
      return true;
    }
  }
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/card')(Card, CardEditConfig); // Use this export for embeding to avoid extra divs generated by MapTo.
exports.default = _default;